import type { JSX } from 'react';
import type { AlertProps } from '@chakra-ui/react';
import { Alert as BaseAlert, AlertDescription, AlertTitle, Flex } from '@chakra-ui/react';

type Props = {
  alertIcon: JSX.Element;
  alertTitle?: string;
  alertDescription?: string;
};

export const Alert = ({
  alertIcon,
  alertTitle,
  alertDescription,
  ...props
}: AlertProps & Props) => (
  <BaseAlert gap={3} alignItems='flex-start' {...props}>
    {alertIcon}
    <Flex flexDirection='column' gap={1}>
      {alertTitle && <AlertTitle>{alertTitle}</AlertTitle>}
      {alertDescription && <AlertDescription>{alertDescription}</AlertDescription>}
    </Flex>
  </BaseAlert>
);
